import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { StateWithCustomCheckout } from '../store';
import { CheckoutActions } from '../store/actions/';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ApplyingBonusFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getApplyingBonus(): Observable<number | undefined> {
    return this.store.select(CheckoutSelectors.getApplyingBonus);
  }

  setApplyingBonus(value: number): void {
    this.store.dispatch(new CheckoutActions.SetApplyingBonus(value));
  }

  resetApplyingBonus(): void {
    this.store.dispatch(new CheckoutActions.ResetApplyingBonus());
  }
}
